import React, { useContext } from "react";

import { FaFacebookF } from "@react-icons/all-files/fa/FaFacebookF";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom-v5-compat";

import { usePageData } from "@onsite_app/MobileOrderingMenu/queries";

import { ErrorBox, TitleBar } from "@online_ordering/Atoms";
import { NavBarContext } from "@online_ordering/Atoms/Navbar";

import { LogoImage } from "@online_ordering/MainPage";
import { useVenue } from "@online_ordering/VenueContext";

import { useTimeoutSearchParam } from "./useTimeoutSearchParam";

export const SocialLinks = () => {
  const venue = useVenue();
  return (
    <div className="flex space-x-12">
      {venue.twitterUserName && venue.twitterUserName.trim().length > 0 && (
        <SocialLink
          href={`https://x.com/${venue.twitterUserName}`}
          icon={<FaTwitter />}
        />
      )}
      <SocialLink href={venue.facebookPageUrl} icon={<FaFacebookF />} />
      {venue.instagramUserName && venue.instagramUserName.trim().length > 0 && (
        <SocialLink
          href={`https://instagram.com/${venue.instagramUserName}`}
          icon={<FaInstagram />}
        />
      )}{" "}
    </div>
  );
};
export const SocialLink = ({
  href,
  icon,
}: {
  href?: string | null;
  icon: React.ReactNode;
}) => {
  if (!href || href.trim().length === 0) {
    return null;
  }
  return (
    <a
      href={href}
      className="rounded-venue-brand bg-venue-tertiary p-8 shadow-venue-brand-style hover:bg-venue-primary hover:text-white"
      target="_blank"
      rel="noreferrer noopener"
    >
      {icon}
    </a>
  );
};

const CheckoutLayout = ({ title }: { title: string }) => {
  const { t } = useTranslation("onsite");

  const menuUuid = usePageData().menuUUID;
  const venue = useVenue();
  const hasJustCancelledPayment = useTimeoutSearchParam("payment");
  const navBarContent = useContext(NavBarContext);
  return (
    <div className="space-y-24 pb-64 md:py-24">
      <div className="md:flex">
        {/*
        When the menu is not enabled, the home page is the vouchers page
         */}
        <Link
          to={menuUuid ? "/" : "/vouchers"}
          className="hidden flex-1 items-center space-x-16 md:flex"
        >
          <div className="w-full max-w-[64px]">
            <LogoImage />
          </div>
          <div className="text-lg font-bold text-venue-primary">
            {venue.name}
          </div>
        </Link>
        <div className="md:flex-1">
          <TitleBar>
            <div className="md:text-4xl md:font-bold">
              {navBarContent.navTitle || title}
            </div>
          </TitleBar>
        </div>
        <div className="hidden w-full flex-1 items-center justify-end space-x-12 md:flex">
          {venue.twitterUserName && venue.twitterUserName.trim().length > 0 && (
            <SocialLink
              href={`https://x.com/${venue.twitterUserName}`}
              icon={<FaTwitter />}
            />
          )}
          <SocialLink href={venue.facebookPageUrl} icon={<FaFacebookF />} />
          {venue.instagramUserName &&
            venue.instagramUserName.trim().length > 0 && (
              <SocialLink
                href={`https://instagram.com/${venue.instagramUserName}`}
                icon={<FaInstagram />}
              />
            )}
        </div>
      </div>

      <div className="space-y-32">
        {hasJustCancelledPayment && (
          <div className="mx-auto max-w-screen-sm">
            <ErrorBox>{t("cart.paymentCancelled")}</ErrorBox>
          </div>
        )}
        <div className="rounded-venue-brand border-venue-tertiary md:mx-auto md:max-w-screen-sm md:space-y-32 md:border-[6px] md:p-16">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default CheckoutLayout;
